import {styled} from "@mui/material/styles";
import { Chip, TextField } from "@mui/material";
import { BaseAutocomplete, MediaQuerys } from "../../styles/GlobalStyle";
import { useColors } from "../../Context/ColorsContext";
const { mobile, desktop } = MediaQuerys;

export const CustomAutocomplete = styled(BaseAutocomplete)(() => ({
    width: '100%',
    borderRadius: 6,
    fontSize: 13,
    '.MuiInputBase-input': {
        padding: 8
    },
    [mobile]: {
        '.MuiInputLabel-root': {
        fontSize: '0.75rem',
      },
    },
    [desktop]: {
        '.MuiFormLabel-root': {
            fontSize: '0.85rem'
        }
    },
	'.MuiAutocomplete-tag': {
		marginTop: 0
	},
	'.MuiChip-root': {
		height: '24px'
	}
}))

export const Input = styled(TextField)(({fontSize}) => ({
    width: '100%',
    '.MuiInputBase-root': {
        borderRadius: 6,
        fontSize: fontSize || 13
    }
}))

export const CustomChip = styled(Chip)(({isValid}) => {
	const { colors } = useColors();
  	return {
		// Modificar color de chip si es válido o no, en caso contrario dejar color original
		background: isValid === true ? colors.green : isValid === false ? colors.darkOrange : '#ebebeb',
		// Modificar color de icono de cerrar dependiendo de si es válido o no
		'.MuiSvgIcon-root': {
			fontSize: 16,
			color: isValid === true || isValid === false ? '#cbccd1' : '#aeaeae'
		},
		'.MuiChip-label': {
			paddingLeft: 9,
			paddingRight: 9,
		},
		[mobile]: {
			fontSize: '0.75rem',
		},
		[desktop]: {
			fontSize: '0.85rem'
		}
	}
})
